const outletList = [
    {
        id: "6628d814221cebabf321b9ab",
        name: "Haofa Repair"
    }
    
];

export default outletList;